import React from 'react';

interface Props {
  errorType: 'not_enrolled' | 'not_authorized' | 'crm_unavailable';
  onLoginClick: () => void;
}

const FONT = "'Adobe Clean', 'Source Sans Pro', 'Segoe UI', sans-serif";

const CONTENT = {
  not_enrolled: {
    title: 'Not Enrolled in APC Program',
    message: 'Your account is not enrolled in the Adobe Partner Connection (APC) program. Please enroll in the APC program to access this application.',
  },
  not_authorized: {
    title: 'Insufficient Access',
    message: 'You do not have sufficient privileges to access this application. Please reach out to your Order Management team or Adobe Account Manager to request access.',
  },
  crm_unavailable: {
    title: 'Service Temporarily Unavailable',
    message: 'We were unable to verify your partner enrolment status due to a temporary service issue. Please try logging in again. If the problem persists, contact your Order Management team.',
  }
};

export function NotAuthorizedModal({ errorType, onLoginClick }: Props) {
  const { title, message } = CONTENT[errorType] ?? CONTENT.crm_unavailable;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: FONT
    }}>
      <div style={{
        background: '#fff', borderRadius: 8, padding: '36px 44px',
        maxWidth: 420, width: '90%', textAlign: 'center',
        boxShadow: '0 12px 48px rgba(0,0,0,0.25)'
      }}>
        <div style={{
          width: 52, height: 52, borderRadius: '50%',
          background: 'linear-gradient(135deg, #eb1000 0%, #b80000 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 18px', fontSize: 22, color: '#fff'
        }}>
          🔒
        </div>
        <h2 style={{ margin: '0 0 8px', color: '#1a1a1a', fontSize: 19, fontWeight: 700, fontFamily: FONT }}>
          {title}
        </h2>
        <p style={{ color: '#666', margin: '0 0 28px', lineHeight: 1.6, fontSize: 13, fontFamily: FONT }}>
          {message}
        </p>
        <button
          onClick={onLoginClick}
          style={{
            background: 'linear-gradient(135deg, #eb1000 0%, #b80000 100%)',
            color: '#fff', border: 'none', borderRadius: 5,
            padding: '10px 28px', fontSize: 14, cursor: 'pointer',
            fontWeight: 600, fontFamily: FONT, letterSpacing: '0.2px'
          }}
        >
          Log In with a Different Account
        </button>
      </div>
    </div>
  );
}
